import React, { useEffect, useState } from "react";
import TopLogo from "./components/logo/top_logo";
import TextLogo from "./components/logo/text_logo";
import emailjs from '@emailjs/browser'

// VersaIT Landing Page
// Single-file React + TypeScript component with internal CSS (no frameworks)

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [formStatus, setFormStatus] = useState<null | string>(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!(form.name.trim() === '' || 
      form.email.trim() === '' || 
      form.message.trim() === '')) {

      setFormStatus("Verzenden...");
      
      emailjs.send(
        "service_lhlnyh3", // <-- jouw EmailJS service ID
        "template_vuwm7bg", // <-- jouw template ID
        {
          user_name: form.name,
          user_email: form.email,
          message: form.message,
        },
        "Kg1A5Nq6bYr758qTz" // <-- jouw public key
      )
      .then((response) => {
        setFormStatus("Bedankt! We nemen snel contact met je op.");
        setForm({ name: "", email: "", message: "" }); // reset form
      },
      (err) => {
        console.error(err);
        setFormStatus("Er ging iets mis, probeer opnieuw.");
      });
    }
    else {
      setFormStatus("Je hebt een van de velden nog niet ingevuld, probeer opnieuw.")
    }
  };

  return (
    <div className="versa">
      <style>{`
        :root{
          --bg:#f7f8fb;
          --accent:#0b74ff;
          --muted:#6b7280;
          --card:#ffffff;
          --glass: rgba(255,255,255,0.6);
          --radius:16px;
          --maxw:1200px;
        }

        *{box-sizing:border-box}
        html,body,#root{height:100%;}
        body{
          margin:0;font-family:Inter,ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial;
          background: linear-gradient(180deg,var(--bg), #ffffff 60%);
          color:#0f172a; -webkit-font-smoothing:antialiased; -moz-osx-font-smoothing:grayscale;
        }

        .versa{min-height:100vh;display:flex;flex-direction:column;align-items:center}

        /* NAV */
        .nav{
          position:fixed;top:16px;left:50%;transform:translateX(-50%);
          width:calc(100% - 40px);max-width:var(--maxw);z-index:60;transition:all 0.35s ease;
          display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-radius:12px;
        }
        .nav--transparent{background:transparent;box-shadow:none}
        .nav--solid{background:rgba(255,255,255,0.95);backdrop-filter: blur(6px);box-shadow:0 6px 24px rgba(17,24,39,0.06);}

        .brand{display:flex;align-items:center;gap:10px}
        .logo{width:42px;height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;}
        .brand h1{font-size:16px;margin:0}
        .brand p{margin:0;font-size:10px;color:var(--muted)}

        .nav-links{display:flex;gap:18px;align-items:center}
        .nav-links a{color:var(--muted);text-decoration:none;font-weight:600}
        .cta-btn{padding:10px 14px;border-radius:10px;background:linear-gradient(90deg,var(--accent),#2bb0ff);color:white;border:none;font-weight:700;cursor:pointer}

        .mobile-toggle{display:none;border:1px solid rgba(15,23,42,0.06);padding:8px;border-radius:8px;background:white}

        /* HERO */
        .hero{
          margin-top:80px;
          border-radius: 12px;
          width:100%;
          max-width:var(--maxw);
          padding:48px 24px 48px;
          display:grid;
          grid-template-columns:1fr 420px;
          gap:40px;
          align-items:center;
          background-image: linear-gradient(90deg, rgb(30, 50, 130) 0%, rgb(60, 200, 240) 35%, rgb(86,226,215) 64%, rgb(30, 50, 130) 100%);
        }
        .hero-left h2{font-size:40px;line-height:1.02;margin:0 0 16px;color:white;}
        .hero-left p{color:var(--muted);margin:0 0 24px;color:white;}
        .hero-ctas{display:flex;gap:14px;}
        
        .card{background:var(--card);border-radius:14px;padding:18px;box-shadow:0 10px 30px rgba(2,6,23,0.06);color:black;}

        /* FEATURES */
        .features{width:100%;max-width:var(--maxw);padding:40px 24px;display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
        .feature{background:linear-gradient(180deg, rgba(11,116,255,0.06), rgba(11,116,255,0.02));padding:22px;border-radius:12px}
        .feature h3{margin:0 0 8px}
        .feature p{margin:0;color:var(--muted)}

        /* SERVICES + CTA */
        .services{width:100%;max-width:var(--maxw);padding:40px 24px}
        .services-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
        .service{background:var(--card);padding:18px;border-radius:12px;box-shadow:0 8px 20px rgba(2,6,23,0.04);position:relative;display:flex;flex-direction:column;justify-content:space-between;}

        /* TESTIMONIALS */
        .testimonials{width:100%;max-width:var(--maxw);padding:40px 24px}
        .test-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:18px}

        /* CONTACT */
        .contact{width:100%;max-width:var(--maxw);padding:40px 24px;display:grid;grid-template-columns:1fr 420px;gap:30px}
        form{display:flex;flex-direction:column;gap:12px}
        input,textarea{padding:12px;border-radius:10px;border:1px solid rgba(15,23,42,0.08);font-size:14px}
        button[type="submit"]{padding:12px;border-radius:10px;border:none;background:var(--accent);color:white;font-weight:700;cursor:pointer}

        /* FOOTER */
        footer{width:100%;max-width:var(--maxw);padding:24px;display:flex;justify-content:space-between;align-items:center;color:var(--muted)}

        /* responsiveness */
        @media (max-width:980px){
          .hero{grid-template-columns:1fr; padding-top:90px}
          .contact, .hero-left{padding:30px 16px}
          .features{grid-template-columns:repeat(2,1fr)}
          .services-grid{grid-template-columns:repeat(2,1fr)}
          .test-grid{grid-template-columns:1fr}
          #contact{display:block}
        }
        @media (max-width:640px){
          .nav{left:12px;right:12px;transform:none;width:calc(100% - 24px)}
          .nav-links{display:none}
          .mobile-toggle{display:block}
          .hero{padding:80px 16px 32px}
          .features{grid-template-columns:1fr}
          .services-grid{grid-template-columns:1fr}
          .hero{gap:20px}
          #contact{display:block}
        }

        /* little UI niceties */
        .fade-in{opacity:0;transform:translateY(8px);animation:fadeIn 0.6s forwards}
        @keyframes fadeIn{to{opacity:1;transform:none}}

      `}</style>

      <nav className={`nav ${scrolled || mobileNavOpen ? "nav--solid" : "nav--transparent"}`} aria-label="Hoofdnavigatie">
        <div className="brand">
          {/* logo */}
          <div className="logo">
            <TopLogo className={"App-logo"}/>
          </div>
          {/* Title */}
          <div>
            <div style={{height: "30px", display: "flex", justifySelf: "left"}}>
              <TextLogo className={"App-logo"} />
            </div>
            <p className="muted">Powered by Wessel Koopman</p>
          </div>
        </div>

        <div className="nav-links" role="navigation" aria-label="Linklijst">
          <a href="#services">Diensten</a>
          <a href="#features">Voordelen</a>
          {/* <a href="#testimonials">Referenties</a> */}
          <a href="#contact" className="cta-btn" style={{color:'white'}} onClick={(e)=>{e.preventDefault();document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}}>Contact</a>
        </div>

        <button className="mobile-toggle" aria-expanded={mobileNavOpen} onClick={()=>setMobileNavOpen(s=>!s)}>
          {mobileNavOpen ? 'Sluit' : 'Menu'}
        </button>
      </nav>

      {/* mobile nav overlay */}
      {mobileNavOpen && (
        <div style={{position:'fixed',inset:0,zIndex:50,background:'rgba(2,6,23,0.45)'}} onClick={()=>setMobileNavOpen(false)}>
          <div style={{position:'absolute',right:18,top:84,background:'white',padding:18,borderRadius:12,minWidth:200}} onClick={(e)=>e.stopPropagation()}>
            <a href="#services" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Diensten</a>
            <a href="#features" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Voordelen</a>
            {/* <a href="#testimonials" onClick={()=>setMobileNavOpen(false)} style={{display:'block',padding:'10px 0'}}>Referenties</a> */}
            <a href="#contact" onClick={()=>{setMobileNavOpen(false);document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}} style={{display:'block',padding:'10px 0'}}>Contact</a>
          </div>
        </div>
      )}

      <header className="hero" role="banner">
        <div className="hero-left">
          <div className="card fade-in" style={{marginBottom:16,display:'inline-block'}}>
            <small style={{color:'var(--accent)',fontWeight:700}}>Nieuw • Onderhoud & Automatisering</small>
          </div>

          <h2 className="fade-in">VersaIT — Automatisering voor MKBers uit Twente</h2>
          <p className="fade-in">Wij helpen installatiebedrijven tijd besparen met slimme automatisering. <br/> Minder administratie, meer tijd voor het echte werk.</p>

          <div className="hero-ctas fade-in" style={{marginTop:22}}>
            <button className="cta-btn" onClick={(e)=>{e.preventDefault();document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}}>Plan een gratis kennismaking</button>
            <a href="#services" style={{alignSelf:'center',padding:'10px 12px',background:'transparent',borderRadius:10,textDecoration:'none',fontWeight:700,color:'white'}}>Onze diensten →</a>
          </div>

          <div style={{display:'flex',gap:12,marginTop:28,alignItems:'center'}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 7l10 5 10-5-10-5z" fill="#0B74FF"/><path d="M2 17l10 5 10-5" stroke="#0B74FF" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              <div>
                <div style={{fontWeight:700,color:'white'}}>Automatisering</div>
                <div style={{fontSize:13,color:'white'}}>Bespaar tijd op offertes & facturen</div>
              </div>
            </div>

            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2v20" stroke="#2BB0FF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 12h14" stroke="#2BB0FF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              <div>
                <div style={{fontWeight:700,color:'white'}}>Koppelingen</div>
                <div style={{fontSize:13,color:'white'}}>Agenda & planning</div>
              </div>
            </div>
          </div>
        </div>

        <aside className="card fade-in" aria-hidden style={{alignSelf:'start'}}>
          <h3 style={{marginTop:0}}>Snel overzicht</h3>
          <p style={{color:'var(--muted)'}}>Kort samengevat wat we voor je doen, zonder technische rompslomp.</p>

          <ul style={{listStyle:'none',padding:0,marginTop:12,gap:10,display:'grid'}}>
            <li style={{display:'flex',gap:12,alignItems:'flex-start'}}>
              <div style={{minWidth:36,minHeight:36,display:'grid',placeItems:'center',borderRadius:10,background:'rgba(11,116,255,0.08)'}}>🔑</div>
              <div>
                <strong>Offertes & facturen</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Bespaar tijd en verminder fouten door te automatiseren</div>
              </div>
            </li>

            <li style={{display:'flex',gap:12,alignItems:'flex-start'}}>
              <div style={{minWidth:36,minHeight:36,display:'grid',placeItems:'center',borderRadius:10,background:'rgba(43,176,255,0.08)'}}>📅</div>
              <div>
                <strong>Planning & afspraken</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Altijd overzicht houden, nooit dubbele afspraken</div>
              </div>
            </li>

            <li style={{display:'flex',gap:12,alignItems:'flex-start'}}>
              <div style={{minWidth:36,minHeight:36,display:'grid',placeItems:'center',borderRadius:10,background:'rgba(11,116,255,0.08)'}}>🫂</div>
              <div>
                <strong>Klantcommunicatie</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Automatische herinneringen & bevestigingen</div>
              </div>
            </li>

            <li style={{display:'flex',gap:12,alignItems:'flex-start'}}>
              <div style={{minWidth:36,minHeight:36,display:'grid',placeItems:'center',borderRadius:10,background:'rgba(11,116,255,0.08)'}}>📘</div>
              <div>
                <strong>Rapportage & administratie</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Alles centraal in een overzicht</div>
              </div>
            </li>
          </ul>
        </aside>
      </header>

      <section id="features" className="features" aria-labelledby="features-heading">
        <h2 id="features-heading" style={{gridColumn:'1 / -1',marginTop:0}}>Waarom kiezen voor VersaIT</h2>

        <div className="feature">
          <h3>Persoonlijke aandacht</h3>
          <p>VersaIT werkt lokaal, snel en persoonlijk. Jij vertelt wat beter kan, VersaIT bouwt de oplossing.</p>
        </div>

        <div className="feature">
          <h3>Transparante prijsstelling</h3>
          <p>Heldere offertes en voorspelbare maandelijkse kosten.</p>
        </div>

        <div className="feature">
          <h3>Gebruiksvriendelijk</h3>
          <p>Tools en dashboards die jouw team direct begrijpt.</p>
        </div>
      </section>

      <section id="services" className="services" aria-labelledby="services-heading">
        
        <h2 id="services-heading">Onze diensten</h2>

        <p style={{color:'var(--muted)'}}>Laat je website door ons bouwen.<br /> Of bespaar 5-10 uur per week aan administratie door onze automatisering.</p>

        <h3 style={{marginTop:32}}>Automatisering</h3>
        <div className="services-grid" style={{marginTop:18}}>
          <div className="service">
            <div>
              <h4>Basisproject</h4>
              <p style={{color:'var(--muted)'}}>Automatisering van offerte, factuur of planning met training</p>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €750,-</small>
            </div>
          </div>

          <div className="service">
            <div>
              <h4>Onderhoud</h4>
              <p style={{color:'var(--muted)'}}>Maandelijkse check, updates & support</p>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €99,- p/maand</small>
            </div>
          </div>
        </div>

        <h3 style={{marginTop:32}}>Websites & Maatwerk</h3>

        <div className="services-grid" style={{marginTop:18}}>
          <div className="service">
            <div>
              <h4>One-pager website</h4>
              <p style={{color:'var(--muted)'}}>Perfect voor kleine bedrijven, ZZP'ers of starters.</p>
              <p style={{color:'var(--muted)'}}>Inclusief:</p>
              <ul style={{color:'var(--muted)'}}>
                <li>Modern Design</li>
                <li>Eén pagina met scroll-secties</li>
                <li>Responsive</li>
                <li>Basis SEO</li>
                <li>Contactformulier</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €750,-</small>
            </div>
          </div>

          <div className="service">
            <div>
              <div>
                <h4 style={{marginBottom:0}}>Standaard bedrijfswebsite</h4>
                <p style={{marginTop:0}}>(3-6 pagina's)</p>
              </div>
              <p style={{color:'var(--muted)'}}>Jouw “main” pakket.</p>
              <p style={{color:'var(--muted)'}}>Inclusief:</p>
              <ul style={{color:'var(--muted)'}}>
                <li>Homepagina</li>
                <li>Dienstpagina</li>
                <li>Contactpagina</li>
                <li>Over ons</li>
                <li>Optioneel portfolio/blog</li>
                <li>SEO + performance optimalisatie</li>
                <li>Kleine CMS-opties</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €1650,-</small>
            </div>
          </div>

          <div className="service">
            <div>
              <h4>Maatwerk website</h4>
              <p style={{color:'var(--muted)'}}>Voor bedrijven die écht professioneel willen gaan.</p>
              <p style={{color:'var(--muted)'}}>Inclusief:</p>
              <ul style={{color:'var(--muted)'}}>
                <li>Volledig custom design</li>
                <li>Uitgebreide contentstructuur</li>
                <li>Animaties / micro-interactions</li>
                <li>Koppelingen (CRM, boekingstool, API's)</li>
                <li>Technische SEO</li>
                <li>SEO + performance optimalisatie</li>
                <li>Dashboards / portals (optioneel met meerprijs)</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Vanaf: €3500,-</small>
            </div>
          </div>

          <div className="service">
            <div>
              <h4>Hosting en onderhoud</h4>
              <ul style={{color:'var(--muted)'}}>
                <li>Domeinbeheer</li>
                <li>Hosting</li>
                <li>SSL</li>
                <li>Onbeperkte tekstupdates</li>
                <li>Uptime monitoring</li>
                <li>Beveiligingsupdates</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €40,- p/maand</small>
            </div>
          </div>
        </div>
        
        {/* <h3 style={{marginTop:32}}>Hosting & onderhoud</h3>

        <div className="services-grid" style={{marginTop:18}}>
          <div className="service">
            <div>
              <h4>Basispakket</h4>
              <ul style={{color:'var(--muted)'}}>
                <li>Domeinbeheer</li>
                <li>Hosting</li>
                <li>SSL</li>
                <li>Kleine contentupdates (15 minuten p/maand)</li>
                <li>Uptime monitoring</li>
                <li>Beveiligingsupdates</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €35,- p/maand</small>
            </div>
          </div>

          <div className="service">
            <div>
              <h4>Pluspakket</h4>
              <ul style={{color:'var(--muted)'}}>
                <li>Alles van basis</li>
                <li>Onbeperkte tekstupdates</li>
                <li>Snelle responsetijd (48 uur)</li>
                <li>Maandelijkse optimalisatie (snelheid / SEO mini-check)</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €50,- p/maand</small>
            </div>
          </div>

          <div className="service">
            <div>
              <h4>Premiumpakket</h4>
              <ul style={{color:'var(--muted)'}}>
                <li>Alles van Plus</li>
                <li>Prioriteit support (24 uur)</li>
                <li>Eén grote update per kwartaal</li>
                <li>Extra analytics/dashboard</li>
              </ul>
            </div>
            <div style={{marginTop:'18px'}}>
              <small style={{color:'var(--muted)'}}>Prijs: €75,- p/maand</small>
            </div>
          </div>
        </div>           */}
      </section>


      {/* !!! Klantreviews !!! */}

      {/* <section id="testimonials" className="testimonials" aria-labelledby="testimonials-heading">
        <h2 id="testimonials-heading">Wat klanten zeggen</h2>
        <div className="test-grid" style={{marginTop:18}}>
          <div className="card">
            <p style={{marginTop:0}}>“VersaIT hielp ons met automatisering van offertes — we besparen nu uren per week.”</p>
            <div style={{display:'flex',gap:10,alignItems:'center',marginTop:12}}>
              <div style={{width:44,height:44,borderRadius:10,background:'linear-gradient(90deg,#0b74ff,#2bb0ff)',display:'grid',placeItems:'center',color:'white'}}>J</div>
              <div>
                <strong>Jeroen van Dijk</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Eigenaar, Installatiebedrijf</div>
              </div>
            </div>
          </div>

          <div className="card">
            <p style={{marginTop:0}}>“Snel, duidelijk en hands-on — precies wat wij nodig hadden.”</p>
            <div style={{display:'flex',gap:10,alignItems:'center',marginTop:12}}>
              <div style={{width:44,height:44,borderRadius:10,background:'linear-gradient(90deg,#6f9cff,#0b74ff)',display:'grid',placeItems:'center',color:'white'}}>M</div>
              <div>
                <strong>Marit Groen</strong>
                <div style={{fontSize:13,color:'var(--muted)'}}>Operations Manager</div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section id="contact" className="contact" aria-labelledby="contact-heading">
        <div>
          <h2 id="contact-heading">Neem contact op</h2>
          <p style={{color:'var(--muted)'}}>Plan een gratis kennismaking of vraag een offerte aan — we komen met een concreet plan.</p>

          <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:12,marginTop:18}}>
            <div className="card">
              <strong>📞 Bel ons</strong>
              <div style={{color:'var(--muted)'}}>+31 6 53 63 18 63</div>
            </div>
            <div className="card">
              <strong>✉️ Email</strong>
              <div style={{color:'var(--muted)'}}>info@versait.nl</div>
            </div>
          </div>

          <div style={{marginTop:18}}>
            <h4>Hoe wij werken</h4>
            <ol style={{color:'var(--muted)'}}>
              <li>Intake & doelstellingen</li>
              <li>Plan & offerte</li>
              <li>Implementatie & training</li>
            </ol>
          </div>
        </div>

        <aside>
          <div className="card">
            <form onSubmit={handleSubmit} aria-label="Contactformulier">
              <label style={{fontSize:13}}>Naam</label>
              <input name="name" value={form.name} onChange={handleChange} placeholder="Jouw naam" />

              <label style={{fontSize:13}}>E-mail</label>
              <input name="email" value={form.email} onChange={handleChange} placeholder="naam@voorbeeld.nl" />

              <label style={{fontSize:13}}>Bericht</label>
              <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder="Kort waar je hulp bij nodig hebt"></textarea>

              <button type="submit">Verstuur bericht</button>

              {formStatus && <div style={{marginTop:10,color: formStatus.startsWith('Bedankt') ? 'green' : 'crimson'}}>{formStatus}</div>}
            </form>
          </div>
        </aside>
      </section>

      <footer>
        <div>© {new Date().getFullYear()} VersaIT — Alle rechten voorbehouden</div>
        <div style={{display:'flex',gap:12}}>
          <a href="/Privacy_Statement" style={{color:'var(--muted)',textDecoration:'none'}}>Privacy</a>
          <a href="/Terms_and_Conditions" style={{color:'var(--muted)',textDecoration:'none'}}>Voorwaarden</a>
        </div>
      </footer>

    </div>
  );
};

export default App;